export default __webpack_public_path__ + "static/media/home.bf91f7ae.svg";